import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import type { DemandBreakdownModeRow } from '@ebalance/proto/bffuser/v1/demand_breakdown_mode_model_pb'

/**
 * 想定モードの一覧からエリアの行だけを取り出す表示フィルタ。並び (需要想定の対象の小売、
 * 続いて対象外の行) は backend が決めた順を保つ。
 */
export function rowsInArea(
  rows: readonly DemandBreakdownModeRow[],
  area: AreaCode | undefined,
): DemandBreakdownModeRow[] {
  if (area === undefined) return []
  return rows.filter((row) => row.areaCode === area)
}

/** 小売の表示。名が unset (母集合にも事業者マスタにも無い) なら事業者コード。 */
export function breakdownRetailerLabel(row: DemandBreakdownModeRow): string {
  return row.retailerName ?? row.retailerCode
}

/** 設定があるか (無い行は一括想定 (既定) で、削除するものが無い)。 */
export function hasBreakdownSetting(row: DemandBreakdownModeRow): boolean {
  return row.updatedAt !== undefined
}
